import { render, staticRenderFns } from "./MetadataPanel.vue?vue&type=template&id=05b4e1ce&scoped=true&"
import script from "./MetadataPanel.vue?vue&type=script&lang=js&"
export * from "./MetadataPanel.vue?vue&type=script&lang=js&"
import style0 from "./MetadataPanel.vue?vue&type=style&index=0&id=05b4e1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4e1ce",
  null
  
)

export default component.exports